import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CapabilityDirective } from './capability.directive';

/**
 * Declares + exports the `*otCapability` directive. `CapabilitiesService` and
 * `CapabilityGuard` are `providedIn: 'root'`, so this module provides nothing —
 * import it wherever `*otCapability` is used (it's imported once at the app root
 * in PR1 so the directive is available app-wide).
 */
@NgModule({
  imports: [CommonModule],
  declarations: [CapabilityDirective],
  exports: [CapabilityDirective],
})
export class CapabilitiesModule {}
